import { render, staticRenderFns } from "./WinBanner.vue?vue&type=template&id=6aa60ba4&"
import script from "./WinBanner.vue?vue&type=script&lang=js&"
export * from "./WinBanner.vue?vue&type=script&lang=js&"
import style0 from "./WinBanner.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports